import * as api from '@/http'
import * as storage from '@/global/storage.js'
import router from '@/router'

export const ActionLogin = async ({ dispatch }, payload) => {
  dispatch('ui/ActionSetLoading', true, { root: true })
  dispatch('ActionSetProcess', true)
  dispatch('ActionSetErrorMessage', false)
  dispatch('ActionSetSuccessMessage', false)
  dispatch('ActionSetEmail', payload.email)
  dispatch('ActionSetPassword', payload.password)

  const user = await api.http.post('login/acquisition', payload).then(
    (response) => response,
    (error) => error
  )
  if (user.status === 200) {
    dispatch('ActionSetProcess', false)
    dispatch('ActionSetSuccessMessage', true)
    dispatch('ActionSetErrorMessage', false)
    dispatch('ActionSetEmail', '')
    dispatch('ActionSetPassword', '')
    dispatch('ActionSetUser', user.data.user)
    dispatch('ActionSetToken', user.data.access_token)

    dispatch('utils/ActionSetStates', {}, { root: true })
    // Actions to populate states of invoice path
    dispatch('acquisitions/ActionSetInvoices', {}, { root: true })
    dispatch('acquisitions/ActionSetInvoicesItems', {}, { root: true })
    dispatch('assets/ActionSetAssets', {}, { root: true })

    setTimeout(() => {
      dispatch('ActionSetSuccessMessage', false)
      setTimeout(() => {
        return router.push('/')
      }, 500)
    }, 2000)
  } else {
    dispatch('ActionSetProcess', false)
    dispatch('ActionSetSuccessMessage', false)
    dispatch('ActionSetErrorMessage', true)
    dispatch('ActionSetPassword', '')
  }
  dispatch('ui/ActionSetLoading', false, { root: true })
}

export const ActionCheckToken = ({ dispatch, state }) => {
  if (state.token) {
    return Promise.resolve(state.token)
  }

  const token = storage.GetLocalToken()

  if (!token) {
    return Promise.reject(new Error('Token Inválido'))
  }

  dispatch('ActionSetToken', token)
  return dispatch('ActionProfile')
}

export const ActionProfile = async ({ dispatch, state }) => {
  try {
    if (storage.GetLocalToken() && state.token) {
      const user = await api.http.get('dash/profile')
      dispatch('ActionSetUser', user.data)
    } else {
      return dispatch('ActionSignOut')
    }
  } catch (error) {
    return dispatch('ActionSignOut')
  }
}

export const ActionSetSuccessMessage = ({ commit }, payload) => {
  commit('SET_success_message', payload)
}

export const ActionSetErrorMessage = ({ commit }, payload) => {
  commit('SET_error_message', payload)
}

export const ActionSetProcess = ({ commit }, payload) => {
  commit('SET_process', payload)
}

export const ActionSetEmail = ({ commit }, payload) => {
  commit('SET_email', payload)
}

export const ActionSetPassword = ({ commit }, payload) => {
  commit('SET_password', payload)
}

export const ActionSetUser = ({ commit }, payload) => {
  commit('SET_user', payload)
}

export const ActionSetToken = ({ commit }, payload) => {
  storage.SetLocalToken(payload)
  storage.SetHeaderToken(payload)
  commit('SET_token', payload)
}

export const ActionSignOut = async ({ dispatch }) => {
  try {
    const logout = await api.http.get('logout/')
    if (logout.status === 200) {
      storage.SetHeaderToken('')
      storage.DeleteLocalToken()
      dispatch('ActionSetUser', {})
      dispatch('ActionSetToken', '')
      router.push('/auth')
    }
  } catch (erro) {
    storage.SetHeaderToken('')
    storage.DeleteLocalToken()
    dispatch('ActionSetUser', {})
    dispatch('ActionSetToken', '')
    router.push('/auth')
  }
}

export const ActionDialodPermissionDenied = ({ commit }, payload) => {
  payload = true
  commit('SET_DialodPermissionDenied', payload)
}
